export const BaseLineClean = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.75199 19.7747C3.97414 18.1774 5.76694 14.9848 5.76694 10H21.2406V13C21.2406 13 21.2406 19.2681 18.7985 20.9142C18.7106 20.9734 18.6059 21 18.4999 21H3.29826C2.73704 21 2.41095 20.2204 2.75199 19.7747Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.3997 16.3325C13.9997 18.9992 12.5 20.5005 11.5 21.0005"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M13.5 1.75C14.7426 1.75 15.75 2.75736 15.75 4V5.4502H11.25V4C11.25 2.75736 12.2574 1.75 13.5 1.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9 5.5H18C19.7949 5.5 21.25 6.95507 21.25 8.75V10H5.75V8.75C5.75 6.95507 7.20507 5.5 9 5.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
